import { createSlotRecipe } from './runtime';

const sliderConfig = {"name":"slider","slots":["root","track","filledTrack","thumb","mark"]}

export const slider = /* @__PURE__ */ createSlotRecipe(sliderConfig)